import { orcidUrlRegex } from '@publishing-engine/domain/validation';

/**
 * This function will return http url for orcid
 * @param orcid string
 * @returns String url or null
 */
export const getOrcidUrl = (orcid: string = '') => {
  if (!orcid) {
    return null;
  }

  // check if it is already a valid orcid url
  const isValidUrl = orcidUrlRegex.test(orcid);
  if (isValidUrl) {
    return orcid;
  }

  return `https://orcid.org/${orcid}`;
};
